export const PRICE_TABLE = "prices"
// Indexes power the recap surfaces that filter prices by product (per-row
// price source resolution) and by (companyId, productId, clientGroupId)
// (the "which override applies to this partner" lookup). userId is
// indexed for the per-salesperson override path even though it's NULL on
// most rows — sparse-Dexie index, cheap.
export const PRICE_TABLE_SCHEMA =
  "id, companyId, productId, clientGroupId, userId, syncId, [companyId+productId], [companyId+productId+clientGroupId]"
